module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "pub-mask"
  }, [_c('div', {
    class: {
      'pub-toast': true, 'pub-toast-normal': _vm.showMessage.length >= 11 ? false : true, 'pub-toast-wide': _vm.showMessage.length >= 11 ? true : false
    },
    attrs: {
      "id": "toast_content"
    },
    domProps: {
      "textContent": _vm._s(_vm.showMessage)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-45febd40!./~/_vux-loader@1.1.30@vux-loader/src/template-loader.js!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/toast.vue
// module id = 349
// module chunks = 15